<template>
	<div>
   <!-- <headlink></headlink>-->
    <headlink v-if="parent == '0'"></headlink>
    <headlink1 v-if="parent == '1'"></headlink1>
    <div class="container ui-flex ui-flex-pack-center">
        	
    <div class="right-container ui-center " >
      <ul v-for="log in msgLog" class="ui-row ui-border-b li-height img" style="width:450px">
    				<li class="ui-col ui-col-10 img"><img src="/static/img/icon3.png" /></li>
					<li class="ui-col ui-col-60 ui-flex-pack-start img left-padding">{{log.eqName}}</li>
					<li class="ui-col ui-col-30 ">
						<span class="time">{{log.msgSendTime | getDate}}</span> 
					</li>
					<li class="ui-col ui-col-10"><img src="/static/img/icon4.png" /></li>
					<li class="ui-col ui-col-90 left-padding">{{log.msgContext}}</li>
		    	</ul>
		    
		    	<ul class="ui-row-flex page">
				    <li v-on:click="nextClick(pageSize-1)" class="ui-col ui-flex ui-flex-pack-start pointer"><div><i class="ui-icon-prev icon-color" ></i></div><div>上一页</div></li>
				   <!-- <li class="ui-col ui-flex ui-flex-pack-center"><div><span v-for="page in pageList"  v-bind:class="[page==pageSize?'error':'' ]" >{{pageSize+"/"+maxPage}}</span></div></li>-->
				 
				  <li class="ui-col ui-flex ui-flex-pack-center"> <span>&nbsp&nbsp&nbsp&nbsp{{pageSize+"/"+maxPage}}&nbsp&nbsp&nbsp&nbsp</span></li>
				  <!-- <li v-on:click="nextClick(pageSize+1)" class="ui-col ui-flex ui-flex-pack-start pointer"><div>下一页</div><div><i class="ui-icon-next icon-color" ></i></div></li>-->
				 
				&nbsp;&nbsp; &nbsp;&nbsp;<li v-on:click="nextClick(pageSize+1)" class="ui-col ui-flex ui-flex-pack-start pointer"><div><i class="ui-icon-next icon-color" ></i></div><div>下一页</div></li>
		    	<li> 
						&nbsp;&nbsp;&nbsp;<input class="yema" type="text"  id="yema" value="">&nbsp;&nbsp;<button v-on:click="tiaozhuan()">跳转</button></li>
		    	
		    	</ul>
		    	
		    	<!--<li> <div align="right">
						<h3><b><input class="yema" type="text"  id="yema" value="">&nbsp;&nbsp;<button v-on:click="tiaozhuan()"> <button>跳转</button></button></b></h3></div></li>-->
     
    
    </div>
 
    
 
    
    
    
    
    
    </div>
  
  
        	
   
 
  </div>
  
</template>

<script>
    import headlink from '@/components/common/headlink'
	import headlink1 from '@/components/common/headlink1'
	import devicemanage1 from '@/components/devicemanage/devicemanage1'
	import devicemanage2 from '@/components/devicemanage/devicemanage2'

export default {
  name: 'addDevice',
  data () {
    return {
    	pageSize:1,
        msgLog:[],
        maxPage:0,
        parent: "0"
    }
  },
  methods:{
  	         tiaozhuan:function(){
  	       var pageSize = $("#yema").val();
  	        	
  	         	if(pageSize >this.maxPage){
            pageSize=1;
          
        }
        
        if(pageSize < 1){
           pageSize=1;
        }
        const history = window.sessionStorage;
        var uid = history.getItem("user");
       
        this.$http.post('/ZYun/HttpService.do', {
          "serviceCode":"1024",
          "uId":uid,
          pageSize: pageSize,
          pageNum:"10"
        })
        .then((response) => {
          if(response.data.respCode=="0000"){
          	this.pageSize = pageSize;
          	this.pageSize=parseInt(this.pageSize);
            this.msgLog = response.data.msgLogList;
          }else{
            console.log(response);
          }
        })
        .catch((response) =>{
          console.log(response);
        })
  	         	
  	         	
  	         
  	         
  	         },
	
  	
  	
 
   nextClick:function(pageSize){
//    console.log(this.maxPage)
        if(pageSize >this.maxPage){
            pageSize=1;
          
        }
        
        if(pageSize < 1){
           pageSize=1;
        }
        const history = window.sessionStorage;
        var uid = history.getItem("user");
        
        this.$http.post('/ZYun/HttpService.do', {
          "serviceCode":"1024",
          "uId":uid,
          pageSize: pageSize,
          pageNum:"10"
        })
        .then((response) => {
          if(response.data.respCode=="0000"){
          	this.pageSize = pageSize;
          	this.pageSize= parseInt(this.pageSize);
            this.msgLog = response.data.msgLogList;
          }else{
            console.log(response);
          }
        })
        .catch((response) =>{
          console.log(response);
        })
    },
    btnClick:function(pageSize){
        const history = window.sessionStorage;
        this.pageSize = pageSize;
        var uid = history.getItem("user");
        this.$http.post('/ZYun/HttpService.do', {
          "serviceCode":"1024",
          "uId":"D62A554C0FA943BEA345749DD4EA078E",
          pageSize:pageSize,
          pageNum:"10"
        })
        .then((response) => {
          if(response.data.respCode=="0000"){
            this.msgLog = response.data.msgLogList;
          }else{
            console.log(response);
          }
        })
        .catch((response) =>{
          console.log(response);
        });
    }
  },
   mounted: function () {
     
			
       
   	     console.log("加载中");      
    const history = window.sessionStorage;
    var uid = history.getItem("user");
    var parent = history.getItem("parent");
			this.parent = parent;
    this.$http.post('/ZYun/HttpService.do', {
      "serviceCode":"1024",
      "uId":uid,
      pageSize:this.pageSize,
      pageNum:"10"
    })
      .then((response) => {
        if(response.data.respCode=="0000"){
          var totoCount = response.data.totoCount;
          var pageNum = this.pageNum;
          this.maxPage = parseInt((response.data.totoCount/10)+1);
          this.msgLog = response.data.msgLogList;
          console.log(response.data.msgLogList);
        }else{
          console.log(response);
        }
      })
      .catch((response) =>{
        console.log(response);
      });
  },
  filters:{
    getDate:function(str){
      var year = str.substring(0,4);
      var month = str.substring(4,6);
      var day = str.substring(6,8);
      var hour = str.substring(8,10);
      var minute = str.substring(10,12);
      var second = str.substring(12,14);
      return year+"-"+month+"-"+day+" "+hour+":"+minute+":"+second;
    }
  },
  components: {
    headlink: headlink,
			headlink1: headlink1,
			devicemanage1: devicemanage1,
			devicemanage2: devicemanage2
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../../../static/css/index.css">
      
</style>



// WEBPACK FOOTER //
// src/components/msgLog/msgLog.vue